import query from './APIServices'

export interface User {
  id: number
  username: string
  email?: string
  displayName: string
  lastLogin?: string
  isActive: boolean
  businessId: number
  avatar: any
  roles: Role[]
  allowedStockAreas: AllowedStockArea[]
  allowedSalesAreas: AllowedSalesArea[]
  allowedManufacturerAreas: AllowedManufacturerArea[]
}

export interface Role {
  name: string
  code: string
}

export interface AllowedStockArea {
  id: number
  name: string
}

export interface AllowedSalesArea {
  id: number
  name: string
}

export interface AllowedManufacturerArea {
  id: number
  name: string
}

export interface UsersParams {
  page: number
  per_page: number
  search: string
}

export const getUsers = async (params: UsersParams) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([_, value]) => value != null)
  )
  const response = await query.get('/security/users', {
    params: cleanParams,
  })
  return response?.data.items as User[]
}

export const getUserById = async (id: number) => {
  const response = await query.get(`/security/user/${id}`)
  return response?.data as User
}
